import script from "./CertificationsDrawer.vue?vue&type=script&setup=true&lang=js"
export * from "./CertificationsDrawer.vue?vue&type=script&setup=true&lang=js"

import "./CertificationsDrawer.vue?vue&type=style&index=0&id=b17777c8&lang=scss"

const __exports__ = script;

export default __exports__